const systemRoutes = [
  {
    path: "sysMng",
    meta: {
      title: "시스템 관리",
      titleEn: "System Management",
    },
    children: [
      {
        path: "menuMng", // sysMng/menuMng
        meta: {
          title: "메뉴 관리",
          titleEn: "Menu Management",
          isDynamic: true,
          menuCd: "MENU_MNG",
        },
        component: () => import("@/views/system/menu/MenuIndex.vue"),
      },
      {
        path: "code", // sysMng/code
        meta: {
          title: "공통 코드 관리",
          titleEn: "Common Code Management",
          isDynamic: true,
          menuCd: "CODE_MNG",
        },
        component: () => import("@/views/system/code/CodeIndex.vue"),
      },
      {
        path: "",
        meta: {
          title: "권한 관리",
          titleEn: "Role",
        },
        children: [
          {
            path: "roleMng", // sysMng/roleMng
            meta: {
              title: "권한 관리",
              titleEn: "Role Management",
              isDynamic: true,
              menuCd: "ROLE_MNG",
            },
            component: () => import("@/views/system/auth/RoleMngIndex.vue"),
          },
          {
            path: "roleMenuMng", // sysMng/roleMenuMng
            meta: {
              title: "권한 별 메뉴 관리",
              titleEn: "Menu Management by Permission",
              isDynamic: true,
              menuCd: "ROLE_MENU_MNG",
            },
            component: () => import("@/views/system/roleMenu/RoleMenuIndex.vue"),
          },
          {
            path: "roleUserMng", // sysMng/roleUserMng
            meta: {
              title: "권한 별 사용자 관리",
              titleEn: "User management by permission",
              isDynamic: true,
              menuCd: "ROLE_USER_MNG",
            },
            component: () => import("@/views/system/roleUser/RoleUserIndex.vue"),
          },
          {
            path: "userRoleMng", // sysMng/userRoleMng
            meta: {
              title: "사용자 별 권한 관리",
              titleEn: "Per-user permission management",
              isDynamic: true,
              menuCd: "USER_ROLE_MNG",
            },
            component: () => import("@/views/system/userRole/UserRoleIndex.vue"),
          },
        ],
      },
      {
        path: "his",
        meta: {
          title: "이력 조회",
        },
        children: [
          {
            path: "login", // sysMng/his/login
            meta: {
              title: "로그인 이력 조회",
              isDynamic: true,
              menuCd: "LOGIN_HIS",
            },
            component: () => import("@/views/system/his/LoginHisIndex.vue"),
          },
          {
            path: "api", // sysMng/his/api
            meta: {
              title: "API 이력 조회",
              isDynamic: true,
              menuCd: "API_HIS",
            },
            component: () => import("@/views/system/his/ApiHisIndex.vue"),
          },
        ],
      },
      {
        path: "settings",
        meta: {
          title: "설정",
        },
        children: [
          {
            path: "semester", // sysMng/settings/semester
            meta: {
              isDynamic: true,
              title: "학년도·학기 관리",
              menuCd: "SEMESTER",
            },
            component: () => import("@/views/system/settings/SemesterIndex.vue"),
          },
        ],
      },
      {
        path: "",
        meta: {
          title: "배치 관리",
        },
        children: [
          {
            path: "batchMng",
            meta: {
              isDynamic: true,
              menuCd: "BATCH_MNG",
            },
            component: () => import("@/views/system/batchMng/BatchMngIndex.vue"),
          },
        ],
      },
    ],
  },
];
export default systemRoutes;
